import { YesNoConfirmModal } from '@common/components/modals';
import { observer } from 'mobx-react';
import React from 'react';

interface ICancelReservationModalProps {
    bodyText: string;
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const CancelReservationModal = observer(({ bodyText, visible, onConfirm, onCancel }: ICancelReservationModalProps) => {
    return (
        <YesNoConfirmModal
            visible={visible}
            busy={false}
            onCancel={onCancel}
            cancelButtonText='No'
            confirmButtonText='Yes'
            onConfirm={onConfirm}
            title="Cancel Appointment"
            description={bodyText} />
    )
});
